import ProjectCard from "../PageLayout/ProjectCard";
import ProjectHeader from "../Projects/ProjectHeader";
import { ProjectType } from "../Utils/ProjectType.ts";
import sharedStyles from "./music-shared.module.css";



export default function April () {


    return (
        <ProjectCard projectName={"April Come She Will"}>

            <ProjectHeader title="apRIL COME SHE WILL" subTitle={"Jan / Josef"} projectType={ProjectType.Music} />

            <p>April Come She Will by Simon & Garfunkel was a really satisfying piece to learn on guitar as it sounds awesome and pushed me to become more comfortable with fingerpicking. I’m often more drawn to cycling through static chords with rich, interesting harmony for a vocalist to sing over.</p>
            <p>It was also fun collaborating with Josef as a performer. He’s usually behind the scenes helping with audio production.</p>

            <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/VWx-0ALG0Lg?si=-Lwr8m36gld6XN97" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        </ProjectCard>
    )
}